import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-course-fee-header',
  templateUrl: './course-fee-header.component.html',
  styleUrls: ['./course-fee-header.component.scss']
})
export class CourseFeeHeaderComponent implements OnInit{

  retrievedData: any;
  retrievedData1: any;

ngOnInit(): void {
  this.retrievedData = localStorage.getItem('userName') ;
  this.retrievedData1 = localStorage.getItem('campusName') ;
}
logout(){
  const logoutPage =localStorage.getItem('logoutPage');
  if(logoutPage){
    window.location.href = logoutPage;
  }
}
}